import { ChangeEvent } from "react";

import { TableFilterProps } from "./TableFilter.types";
import styles from "./TableFilter.module.scss";

export const TextFilterComponent: React.FC<TableFilterProps> = ({ value, onChange }) => (
  <input
    className={styles.control}
    type="search"
    value={typeof value === "string" ? value : ""}
    onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
    aria-label="Filter text"
  />
);